import _ from "lodash";

type CountryItem = {
  shortName: string;
  acceptLanguage: string;
  timezone: string;
  name: string;
  code: string;
  locale: string;
  htmlLangCode: string;
  phoneCustomerSupport: string;
  langCode: string;
  countryCode: string;
  application: string;
  domain: string;
  testDomain: string;
  validNameSurnameCharacters: string;
  infoEmail: string;
  currency: Currency;
  number: Number;
  pinRequestWaitDuration: Number;
  dateFormats: DateFormats;
  phoneMinLength: string;
  phoneMaxLength: string;
  phonePrefix: string;
  patterns: Patterns;
  loan: Loan;
};

type Loan = {
  duration: number;
  dailyRate: number;
};

type Patterns = {
  postCode: string;
  email: string;
  pin: string;
  otp: string;
  password: string;
  phone: string;
  phoneModel: string;
  allPhone: string;
};

type DateFormats = {
  short: string;
  long: string;
  longWithDay: string;
  shortWithClock: string;
  inputPlaceholder: string;
};

type Number = {
  decimal: string;
  thousand: string;
  precision: number;
};

type Currency = {
  name: string;
  abbr: string;
  symbol: string;
  position: string;
  isSeperate: boolean;
};

const COUNTRY = {
  shortName: "es",
  acceptLanguage: "es-ES",
  timezone: "Europe/Madrid",
  name: "Spain",
  code: "es",
  locale: "es",
  htmlLangCode: "es",
  langCode: "es_ES",
  countryCode: "+34",
  application: "MyKredit_ES",
  domain: "https://mykredit.es",
  testDomain: "http://test.v2.mykredit.com",
  infoEmail: "info@mykredit.es",
  phoneCustomerSupport: "+3491 2907100",
  phoneCustomerTollFreeSupport: "+3490 0730072",
  phoneCustomerSupportLabel: "912 907 100",
  phoneCustomerTollFreeSupportLabel: "900 730 072",
  pinRequestWaitDuration: 60,
  currency: {
    name: "Euro",
    abbr: "EUR",
    symbol: "€",
    position: "right",
    isSeperate: false,
  },
  number: {
    decimal: ",",
    thousand: ".",
    precision: 2,
  },
  dateFormats: {
    short: "DD/MM/YYYY",
    long: "dddd DD MMMM YYYY",
    longWithDay: "dddd DD MMMM YYYY, ddd",
    shortWithClock: "DD/MM/YYYY HH:mm:ss",
    inputPlaceholder: "YYYY/MM/DD",
  },
  phoneMinLength: "9",
  phoneMaxLength: "9",
  phonePrefix: "",
  dniMaxLength: "9",
  dniMinLength: "9",
  validNameSurnameCharacters:
    "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZzáéíóúüñÁÉÍÓÚÜÑ ",
  patterns: {
    postCode: /^[0-9]{5}$/,
    dni: /^(?!00000000[a-zA-Z]$)(?!00000001[a-zA-Z]$)(?!([0-9])\1{7}[a-zA-Z]$)(?!.*(?:01234567|12345678|23456789|76543210|87654321|98765432)[a-zA-Z]$)(?![xyzXYZ](?:0123456|1234567|2345678|3456789|6543210|7654321|8765432|9876543)[a-zA-Z]$)(?![xyzXYZ]0000000[a-zA-Z]$)([xyzXYZ]{1}[0-9]{7}[a-zA-Z]{1}|[0-9]{8}[a-zA-Z]{1})$/,
    email:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    pin: /^[0-9]{4}$/,
    otp: /^[0-9a-zA-Z]{4,6}$/,
    password: /^.{4,20}$/,
    phone: /^(6[0-9]{8}|7[0-9]{8})$/,
    allPhone: /^(6[0-9]{8}|7[0-9]{8}|8[0-9]{8}|9[0-9]{8})$/,
  },
  loan: {
    duration: 20,
    dailyRate: 0.75,
  },
};

export default COUNTRY;
